import React from "react";

const HeadingText = ({
  text,
  size = "4xl",
  mb = "mb-8",
  font = "font-extrabold",
  color = "text-brand-dark",
  className = "",
}) => {
  return (
    <h2
      className={`text-${size} ${font} ${color} ${mb} tracking-tighter ${className}`}
    >
      {text}
    </h2>
  );
};

export default HeadingText;
